// extracted by mini-css-extract-plugin
export default {"pilha":"avisos_pilha__bDYQk"};